import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

interface DeleteButtonProps {
    onClick?: () => void;
    iconOnly?: boolean;
    className?: string;
    disabled?: boolean;
    /** Kept for API compatibility; destructive actions always speak danger rose. */
    color?: string;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({ onClick, iconOnly = false, className, disabled = false }) => (
    <button
        type="button"
        disabled={disabled}
        onClick={onClick}
        className={`st-btn st-btn--danger${iconOnly ? ' st-btn--icon' : ''}${className ? ` ${className}` : ''}`}
    >
        <FontAwesomeIcon icon={faTrash} />
        {!iconOnly && <span>Zmazať</span>}
    </button>
);

export default DeleteButton;
